export default __webpack_public_path__ + "static/media/summerCamp.ba378b77.jpg";